export default {
    data() {
        return {
            width: 0
        }
    },
    computed: {
        mobile() {
            return this.width <= 1024
        },
        desktop() {
            return !this.mobile
        },
        displayClasses() {
            return {
                'mobile': this.mobile,
                'mobile-small': this.mobile && this.width < 360,
                'desktop': this.desktop
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize() {
            this.width = window.innerWidth
        }
    }
}